<template>
  <div class="phone-charge">
    <!-- <van-cell-group>
      <div class="tabs__wrapper">
        <div
          class="tabs__item"
          :class="{ 'is-active': selectedTab.value === tab.value }"
          v-for="tab in tabs"
          :key="tab.value"
          @click="selectedTab = tab"
        >
          {{ tab.name }}
        </div>
      </div>
    </van-cell-group> -->

    <section class="phone-charge__main">
      <div class="phone-field__wrapper">
        <field-format-phone
          :disabled="isZC || isXDCXDisable"
          v-model="phoneNo"
          class="phone-field__input flex-item"
        />
        <img
          v-if="phoneNo && !(isZC || isXDCXDisable)"
          @click="deletePhone"
          class="phone-field__delete"
          src="@/assets/img/car-life/ic_delete_code.png"
        >
        <div
          class="phone-field__tip flex-item"
          :class="{ 'is-error': phoneTip.type === 'error' }"
        >
          {{ phoneTip.content }}
        </div>
      </div>

      <denomination-select
        v-if="initSku"
        ref="denominationSelect"
        :items="chargeOptions"
        :disabled="pageDisable"
        keep-selected
        :show-sale-price="showSalePrice"
        :product-sku-code="productSkuCode"
        @getPrice="getPriceHandle"
      />

      <div
        v-if="selectedTab.value === CHARGE_TYPE.slow"
        class="tip"
      >
        充值后最迟在48小时内到账，请耐心等候
      </div>
    </section>

    <van-cell-group class="phone-charge__right">
      <van-field
        is-link
        readonly
        label="可用权益"
        input-align="right"
        :placeholder="rightDisable ? '暂无可用权益' : '请选择权益'"
        :value="rightRulePackageBindId ? selectedRight.rightName : rightDiscount"
        @click="openRight"
      />
    </van-cell-group>

    <template>
      <div class="right-field__wrapper">
        <right-selector
          v-model="selectedRight"
          :key-adapter="{ rightCode: 'rightCode' }"
          :right-options="rightList"
          ref="rightSelector"
          :disabled="rightDisable"
          @select="selectRightClick"
        />
      </div>
    </template>

    <div
      class="rule-wrap"
      v-if="isZC"
    >
      <van-popover
        v-model="showPopover"
        theme="dark"
        placement="bottom-start"
      >
        <template>
          <div class="popup-msg">请阅读并勾选后再充值</div>
        </template>
      </van-popover>
      <van-checkbox
        v-model="ruleReaded"
        icon-size="16px"
        checked-color="#ffa349"
      >我已阅读并同意</van-checkbox>

      <div
        class="link"
        @click="viewAgreement('privacyPolicy')"
      >
        《个人信息保护隐私政策》
      </div>
      <div
        class="link"
        @click="viewAgreement('processingRules')"
      >
        《个人客户信息处理规则》
      </div>
      <div
        class="link"
        @click="viewAgreement('licenseAgreement')"
      >
        《个人信息处理授权协议》
      </div>
    </div>

    <van-button
      class="button--submit"
      :disabled="isDisabled"
      :loading="chargeBtnLoading"
      loading-type="spinner"
      loading-text="提交中..."
      :class="{ 'bg-orange': isZC }"
      @click="submit"
    >
      ¥{{ sum }}立即充值
    </van-button>
    <div
      role="button"
      class="button--record"
      @click="checkRecords"
    >充值记录</div>
  </div>
</template>

<script>
import RightSelector from '@/components/right-selector.vue';
import DenominationSelect from '@/components/denomination-select';
import FieldFormatPhone from '@/components/field-format-phone.vue';
import { REGEX_PHONE } from '@/common/regex';
import {
  findValidRight,
  carLifePayPre,
  carLifeOrderCreate,
  getRechargeProductInfo,
  phoneMoblieAttribution,
  carLifeOrderDetail,
  loginNoToken
} from '@/common/api.js';
import Pay from '@/common/weixin.js';
import { CarLifeOrderStatus } from '@/common/constant.js';
import { Toast } from 'vant';
import { cookieSet } from '@/common/cookie';
import { cloneDeep, debounce } from 'lodash';
import Utils from '@/common/util.js';

// 充值方式
const CHARGE_TYPE = {
  standard: '01', // 话费充值
  slow: '02' // 话费慢充
};

export default {
  name: 'PhoneCharge',

  components: {
    RightSelector,
    DenominationSelect,
    FieldFormatPhone
  },

  data() {
    return {
      CHARGE_TYPE,
      tabs: [
        { name: '话费充值', value: CHARGE_TYPE.standard },
        { name: '话费慢充', value: CHARGE_TYPE.slow }
      ],
      // 已选的充值方式tab
      selectedTab: { name: '话费充值', value: CHARGE_TYPE.standard },
      // 充值手机号
      phoneNo: '',
      // 手机号右侧的提示
      phoneTip: {
        type: '', // 消息类型 'error' 则字体为红色
        content: '' // 提示内容
      },

      // 充值面额选项
      chargeOptions: [],
      // 展示售价
      showSalePrice: false,
      // 已选的充值选项
      selectedChargeInfo: {},
      // 权益列表
      rightList: [],
      // 已选择的权益
      selectedRight: {
        discount: undefined
      },

      pageDisable: true,
      orderNo: '', // 订单编号
      curProductInfo: {}, // 当前选中的产品info
      curRigthItem: {}, // 当前选中的权益item
      productCode: '', // 产品code
      // sum: "",
      contactPhone: '', // 用户手机号
      checkPayCount: 3, // 是否支付最多检查次数
      checkPayTime: 3000, // 每次检查是否支付中间的间隔
      originalRightList: [],
      rightDiscount: '', // 带-号的

      chargeBtnLoading: false, // 充值按钮loading
      showPopover: false,
      ruleReaded: false,
      productSkuCode: '',
      initSku: true,
      phoneAttributionKey: '', // 手机归属地
      rightRulePackageBindId: ''
    };
  },

  computed: {
    sum() {
      let salePrice = 0;
      let discount = 0;
      let sum = 0;
      this.setRightContent();
      if (!this.isEmptyObject(this.selectedChargeInfo)) {
        salePrice = this.selectedChargeInfo.salePrice;
        const skuCode = this.selectedChargeInfo.productSkuCode;
        if (skuCode && !this.isEmptyObject(this.selectedRight)) {
          const rightrRule = this.selectedRight.rightRuleList;
          rightrRule.forEach((item) => {
            if (item.skuCode === skuCode) {
              discount =
                item.rightType === '2'
                  ? Number(this.getSalePrice(item.skuCode))
                  : item.rightDiscount;
              this.setRightContent(item);
            }
          });
        }
      }

      sum = Utils.subtraction(salePrice, discount);
      return sum > 0 ? sum : '0.00';
    },
    isDisabled() {
      return this.isEmptyObject(this.selectedChargeInfo) || this.$route.query.companyNo === 'XDCX' && this.rightList.length <= 0;
    },
    rightDisable() {
      return !(this.rightList && this.rightList.length > 0);
    },
    // 是否众诚
    isZC() {
      return this.$route.query.companyNo === 'UTIC';
    },
    isXDCXDisable() {
      if (this.$route.query.companyNo === 'XDCX') {
        return true;
      } else {
        return false;
      }
    },
    isXDCX() {
      if (this.$route.query.companyNo === 'XDCX' && this.$route.query.erId) {
        return true;
      } else {
        return false;
      }
    }
  },

  watch: {
    phoneNo(phoneNo) {
      if (!phoneNo || phoneNo.length < 11) {
        this.resetPhoneDeps();
        return;
      }

      if (REGEX_PHONE.test(phoneNo)) {
        this.handlePhoneValid(phoneNo);
        // this.phoneTip = { type: "info", content: "广东 电信" };
        // this.pageDisable = false;
      } else {
        this.phoneTip = {
          type: 'error',
          content: '请输入正确的手机号码'
        };
        this.resetRight();
      }
    },

    selectedTab: {
      handler: 'handleTabChange',
      deep: true
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      let token;
      if (this.$route.query.token) {
        token = this.$route.query.token;
        token = (token || '').replace(/\s/g, '+');
      }

      const _phone = localStorage.getItem('_phone');
      if (_phone) {
        this.contactPhone = _phone;
      }

      if (this.$route.query.authorizeToken) {
        const res = await loginNoToken({
          channelToken: this.$route.query.authorizeToken,
          companyNo: this.$route.query.companyNo
        });

        token = res.token;
        this.contactPhone = res.mobile;
        localStorage.setItem('_phone', this.contactPhone);
        this.phoneNo = this.contactPhone;
      }
      if (
        token &&
        (document.domain.indexOf('vas') > -1 || document.domain.indexOf('zengzhi') > -1)
      ) {
        cookieSet('token', token);
      }

      // 处理小程序跳转
      if (this.$route.query.phone) {
        this.contactPhone = this.$route.query.phone;
        localStorage.setItem('_phone', this.contactPhone);
        this.phoneNo = this.contactPhone;
      }

      if (this.$route.query.orderNo) {
        const arr = this.$route.query.orderNo;
        if (Array.isArray(arr)) {
          this.orderNo = arr[arr.length - 1];
        } else {
          this.orderNo = this.$route.query.orderNo;
        }
      }

      if (this.$route.query.isCallBack) {
        this.showConfirmDialog();
      }

      if (REGEX_PHONE.test(this.phoneNo)) {
        this.handlePhoneValid(this.phoneNo);
      }

      if (this.$route.query.rightRulePackageBindId) {
        this.rightRulePackageBindId = this.$route.query.rightRulePackageBindId;
      }
      await this.getChargeOptions();
    },
    handleTabChange(tab) {
      this.resetChargeOption();
      this.resetRight();
      this.getChargeOptions();
    },

    /**
     * 重置充值金额
     */
    resetChargeOption() {
      this.selectedChargeInfo = {};
      this.skuCodeGetRight();
      this.$refs.denominationSelect && this.$refs.denominationSelect.reset();
    },

    resetRight() {
      this.selectedRight = {};
      this.rightList = cloneDeep(this.originalRightList);
    },

    async handlePhoneValid(phoneNo) {
      // 获取手机归属地
      const res = await phoneMoblieAttribution({ phone: phoneNo });
      if (!res || !res.operator) {
        this.phoneTip = {
          type: 'error',
          content: '手机归属地错误'
        };
        Toast('手机归属地错误');
        return;
      }
      this.pageDisable = false;
      const msg = res.city + ' ' + res.operator;
      this.phoneTip = { type: 'info', content: msg };
      const dict = {
        移动: 'mobilePriceToYuan',
        联通: 'unicomPriceToYuan',
        电信: 'telecomPriceToYuan'
      };
      const key = res.operator;
      const value = dict[key];
      this.phoneAttributionKey = value;
      this.chargeOptions.forEach((item) => {
        item.salePrice = this.rightRulePackageBindId ? item.productSkuBasePriceToYuan
          : item.productSkuInfo[0][value];
      });
      this.showSalePrice = true;
    },

    async getRightList() {
      try {
        if (!this.productCode) {
          return;
        }
        if (!this.contactPhone) {
          Toast('没有用户手机号');
          return;
        }
        this.$toast.loading({
          message: '正在处理权益...',
          forbidClick: true,
          duration: 0
        });
        const res = await findValidRight({
          phone: this.contactPhone,
          productCode: this.productCode,
          rightPackageCode: this.$route.query.erId
        });
        this.$toast.clear();
        if (!res) {
          return;
        }
        this.originalRightList = res;
        this.originalRightList.forEach((item) => {
          item.rightId = item.rightPackageCode + '-' + item.rightCode;
          item.timesLeft = item.validCount;
          item.disabled = true; // 都是禁用的
        });
        this.rightList = cloneDeep(this.originalRightList);

        // source 来源，以便判断小程序跳转
        if (this.$route.query.source === 'wxapp' || this.isXDCX) {
          this.rightList && this.rightList.forEach(item => {
            if (this.$route.query.rightRulePackageBindId == item.rightRulePackageBindId || this.$route.query.erId == item.rightPackageCode) {
              this.selectedRight = item;
              item.rightRuleList && item.rightRuleList.forEach(items => {
                this.chargeOptions.forEach(i => {
                  if (this.phoneAttributionKey) {
                    i.salePrice = this.rightRulePackageBindId ? i.productSkuBasePriceToYuan
                      : i.productSkuInfo[0][this.phoneAttributionKey];
                  }
                  if (items.skuValueCode === i.skuValueCode) {
                    this.selectedChargeInfo = i;
                    this.productSkuCode = i.productSkuCode;
                    const salePrice = (items.rightType === '2' ? this.getSalePrice(items.skuCode) : items.rightDiscount);
                    if (salePrice) {
                      this.rightDiscount = '-' + salePrice;
                    } else {
                      this.rightDiscount = '';
                    }
                  }
                });
              });
            }
          });
        }

        // 获取权益后也要计算sku #1011611
        this.skuCodeGetRight();
      } catch {
        console.log();
      }
    },

    // 根据sku筛选权益
    skuCodeGetRight() {
      const productSkuCode = this.selectedChargeInfo.productSkuCode;
      const rightList = cloneDeep(this.originalRightList);
      if (!productSkuCode) {
        this.rightList = rightList;
        return;
      }

      const sortedRights = rightList
        .map((item) => {
          const rightRuleList = item.rightRuleList || [];
          const isMatched = rightRuleList.some(
            ({ skuCode }) => productSkuCode === skuCode
          );
          return {
            ...item,
            disabled: !isMatched
          };
        })
        .sort((a) => (a.disabled ? 1 : -1)); // 排序，有效的放前面

      this.rightList = sortedRights;
    },

    /*
     * 获取产品信息
     */
    async getChargeOptions() {
      const res = await getRechargeProductInfo({
        rechargeType: 1
      });
      if (!res) {
        Toast('当前服务已停用');
        return;
      }
      this.productCode = res.productCode; // 需要传给权益
      this.getRightList(); // 需请求成功，产品，再请求权益
      const pavListItem = res.pavList[0]; // 第一个产品规格
      this.chargeOptions = pavListItem.psvList; // 取产品的sku
      const productSkuRespVoList = res.productSkuRespVoList;
      this.chargeOptions.forEach((skuItem) => {
        skuItem.productSkuInfo = productSkuRespVoList.filter((item) => {
          if (item.skuValueCode === skuItem.skuValueCode) {
            skuItem.id = item.productSkuCode;
            skuItem.value = skuItem.skuValueName; // 产品规格价格
            skuItem.salePrice = item.productSkuBasePriceToYuan; // 产品销售价格
            skuItem.productSkuBasePriceToYuan = item.productSkuBasePriceToYuan; // 产品销售价格
            skuItem.productSkuCode = item.productSkuCode; // 用于筛选权益
            return item;
          }
        });
      });
    },

    getPriceHandle(price) {
      this.selectedChargeInfo = price || {};
      this.selectedRight = {};
      this.rightDiscount = '';
      this.skuCodeGetRight();
      // 选择项目后默认选中权益
      if (this.rightRulePackageBindId) {
        const i = price;
        this.rightList && this.rightList.forEach(item => {
          item.rightRuleList && item.rightRuleList.forEach(items => {
            if (items.skuValueCode === i.skuValueCode) {
              this.selectedRight = item;
            }
          });
        });
      }
    },

    /**
     * 重置依赖手机号的数据
     */
    resetPhoneDeps() {
      this.pageDisable = true;
      this.showSalePrice = false;
      this.phoneTip = {};
      // this.rightList = [];
      this.resetRight();
      this.selectedChargeInfo = {};
      this.selectedRight = {};
      this.$refs.denominationSelect && this.$refs.denominationSelect.reset();
      this.skuCodeGetRight();
    },

    checkRecords() {
      this.$router.push({ path: '/phoneChargeRecords' });
    },
    isEmptyObject(obj) {
      if (JSON.stringify(obj) == '{}') {
        return true;
      } else {
        return false;
      }
    },
    submit: debounce(
      async function() {
        if (this.$route.query.companyNo === 'XDCX' && this.sum > 0.00) {
          this.$toast('没有可用卡券');
          return;
        }
        if (this.isZC && !this.ruleReaded) {
          this.showPopover = true;
          return;
        }
        if (this.isEmptyObject(this.selectedChargeInfo)) {
          return;
        }
        const productItem = this.selectedChargeInfo.productSkuInfo[0];
        const parmas = {
          contactPhone: this.contactPhone || this.phoneNo,
          productSkuCode: productItem.productSkuCode,
          rechargePhone: this.phoneNo
        };

        if (!this.isEmptyObject(this.selectedRight)) {
          parmas.rightCode = this.selectedRight.rightCode;
          parmas.rightPackageCode = this.selectedRight.rightPackageCode;
          parmas.rightRuleCode = this.selectedRight.rightRuleCode;
          parmas.rightPackageBindId = this.selectedRight.rightPackageBindId;
          parmas.version = this.selectedRight.version;
        }

        try {
          this.chargeBtnLoading = true;
          const res = await carLifeOrderCreate(parmas);
          this.orderNo = res.orderNo;
          if (res.needPay) {
            const envMap = ['1', '1', '4'];
            // 调起预支付接口成功后
            const prepayRs = await carLifePayPre({
              payType: envMap[this.$browserEnv], // 支付环境
              orderNo: this.orderNo,
              openId: this.$route.query.openId || null,
              appCode: this.$route.query.appId || null
            });
            this.prePayHandle(prepayRs);
          } else {
            this.prePaySuccess();
          }
        } finally {
          this.chargeBtnLoading = false;
        }
      },
      3000,
      { leading: true, trailing: false }
    ),
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },
    prePaySuccess() {
      this.$router.replace({
        name: 'resultPage',
        query: {
          orderNo: this.orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: '00'
        }
      });
    },
    prePayFail() {
      this.$router.replace({
        name: 'phoneChargeDetail',
        query: {
          orderNo: this.orderNo
        }
      });
    },
    selectRightClick(item) {
      this.selectedRight = item;
    },
    async showConfirmDialog() {
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      this.checkPay();
    },
    async checkPay() {
      try {
        const res = await carLifeOrderDetail({
          orderNo: this.orderNo
        });
        this.$toast.clear();
        // 待支付的，去订单详情
        if (res.rechargeStatus == CarLifeOrderStatus.unpaid) {
          this.prePayFail();
        } else {
          this.prePaySuccess();
        }
      } catch (error) {
        this.$toast.clear();
      }
    },
    deletePhone() {
      this.phoneNo = '';
    },

    openRight() {
      if (this.isXDCX) {
        return;
      }
      this.$refs.rightSelector.openPopup();
    },

    getSalePrice(skuCode) {
      const sku = this.chargeOptions.find((item) => item.productSkuCode === skuCode);
      return sku.salePrice;
    },

    setRightContent(item) {
      if (item) {
        // 根据面值选中的权益优惠的sdkCodu、rightRuleCode，先记录
        this.selectedRight.selectSkuCode = item.skuCode;
        this.selectedRight.rightRuleCode = item.rightRuleCode;
        this.selectedRight.rightCode = item.rightCode;
        this.rightDiscount =
          '-' +
          (item.rightType === '2' ? this.getSalePrice(item.skuCode) : item.rightDiscount);
        return;
      }
      this.rightDiscount = '';
    },
    viewAgreement(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
$color--primary: #3399ff;

.phone-charge {
  min-height: 100vh;
  overflow-y: scroll;
  background: #f4f6f7;

  // 顶部tab
  .tabs {
    &__wrapper {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 0.36rem;
      height: 0.98rem;
      font-family: PingFangSC-Medium;
      // font-weight: bold;
    }

    &__item.is-active {
      position: relative;
      color: $color--primary;

      &::after {
        background: $color--primary;
        content: "";
        width: 0.6rem;
        height: 0.06rem;
        border-radius: 0.03rem;
        position: absolute;
        top: 0.46rem;
        left: 0.44rem;
      }
    }
  }

  &__right {
    margin-top: 0.24rem;
    height: 0.98rem;
    font-size: 0.32rem;

    .van-cell {
      padding: 0.25rem 0.4rem;
      font-size: inherit;
      height: 100%;
    }
  }

  &__main {
    margin-top: 0.24rem;
    background: #fff;

    // 手机号输入区域
    .phone-field {
      &__wrapper {
        display: flex;
        align-items: center;
        width: 100vw;
        height: 1.36rem;
        border-bottom: 0.02rem solid rgb(230, 230, 230);
      }

      &__input {
        font-size: 0.48rem;
        flex: 1;
        padding-left: 0.4rem;
      }

      &__tip {
        font-size: 0.32rem;
        text-align: right;
        padding-right: 0.4rem;

        &.is-error {
          font-size: 0.24rem;
          color: #ff3333;
        }
      }

      &__delete {
        height: 0.4rem;
        width: 0.4rem;
        padding-right: 0.1rem;
      }
    }

    // 慢充提示
    .tip {
      font-size: 0.24rem;
      color: #787878;
      padding: 0 0.4rem 0.4rem 0.4rem;
    }
  }

  // 权益选择
  .right-field__wrapper {
    margin-top: 0.24rem;
  }

  .rule-wrap {
    padding-left: 32px;
    font-size: 12px;
    line-height: 20px;
    color: #969696;
    display: flex;
    flex-wrap: wrap;

    .link {
      color: #ffa349;
    }

    .van-checkbox__label {
      color: #969696;
      font-size: 12px;
    }
  }

  .button {
    // 充值按钮
    &--submit {
      height: 0.96rem;
      width: 6.7rem;
      border-radius: 0.16rem;
      background: $color--primary;
      color: #fff;
      font-size: 0.36rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.72rem auto 0.48rem;

      &.bg-orange {
        background: #ffa349;
      }
    }

    // 充值记录
    &--record {
      font-size: 0.32rem;
      text-align: center;
      color: #4d7399;
    }
  }
}
.popup-msg {
  font-size: 16px;
  color: #ffffff;
  padding: 9px 15px;
}
.van-popover__content {
  border-radius: 4px;
}
</style>
